import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Content_ProviderCommonFragmentFragmentDoc } from './ContentProviderCommonFragment.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type UpdateProviderMetadataMutationVariables = Types.Exact<{
  contentProvider: Types.ContentProviderUpdateByContentIdInput
}>

export type UpdateProviderMetadataMutation = {
  __typename?: 'Mutation'
  contentProviderUpdateByContentId?: {
    __typename?: 'ContentProviderMutationResponse'
    contentProvider?: {
      __typename?: 'ContentProvider'
      metadata?: any | null
      contentId?: string | null
    } | null
  } | null
}

export const UpdateProviderMetadataDocument = gql`
  mutation UpdateProviderMetadata($contentProvider: ContentProviderUpdateByContentIdInput!) {
    contentProviderUpdateByContentId(contentProvider: $contentProvider) {
      contentProvider {
        ...Content_ProviderCommonFragment
        metadata
      }
    }
  }
  ${Content_ProviderCommonFragmentFragmentDoc}
`
export type UpdateProviderMetadataMutationFn = Apollo.MutationFunction<
  UpdateProviderMetadataMutation,
  UpdateProviderMetadataMutationVariables
>

/**
 * __useUpdateProviderMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMetadataMutation, { data, loading, error }] = useUpdateProviderMetadataMutation({
 *   variables: {
 *      contentProvider: // value for 'contentProvider'
 *   },
 * });
 */
export function useUpdateProviderMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProviderMetadataMutation,
    UpdateProviderMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateProviderMetadataMutation,
    UpdateProviderMetadataMutationVariables
  >(UpdateProviderMetadataDocument, options)
}
export type UpdateProviderMetadataMutationHookResult = ReturnType<
  typeof useUpdateProviderMetadataMutation
>
export type UpdateProviderMetadataMutationResult =
  Apollo.MutationResult<UpdateProviderMetadataMutation>
export type UpdateProviderMetadataMutationOptions = Apollo.BaseMutationOptions<
  UpdateProviderMetadataMutation,
  UpdateProviderMetadataMutationVariables
>
